<template>
  <div>
    <v-divider></v-divider>
    <v-layout wrap fill-height>
      <v-flex class="sidebar-slot">
        <AppSidebar :items="items" v-model="sideNav" />
      </v-flex>
      <v-flex class="main-content-flex">
        <v-layout wrap pb-0 mb-0>
          <v-flex xs12 sm12 md12 lg12 pb-0 mb-0>
            <AppHeader class="pb-0 mb-0" @toggle-nav="sideNav = !sideNav" />
          </v-flex>
          <v-flex xs12 pt-0 mt-0><v-divider class="pt-0 mt-0"></v-divider></v-flex>
          <v-flex xs12 sm12 md12 lg12 pl-0>
            <v-layout wrap justify-center :style="$route.name == 'adminDashboard'
                ? 'background-color: #ffffff'
                : 'background-color: #f6fff9'
              ">
              <v-flex xs12>
                <v-card min-height="100vh" :color="$route.name == 'Dashboard' ? 'transparent' : '#FFFFFF'
                  " flat>
                  <v-layout wrap justify-center>
                    <v-flex xs12>
                      <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import AppHeader from "@/components/Common/appHeadersarpa";
import AppSidebar from "@/components/Common/appSidebar";

export default {
  components: {
    AppHeader,
    AppSidebar,
  },
  data() {
    return {
      //open state for the sidebar; only used below md, where it overlays
      sideNav: false,
      items: [
        {
          title: "Dashboard",
          icon: "mdi-view-dashboard",
          path: "/emergencyuser/adminDashboard",
        },
        { title: "My Details", icon: "mdi-account", path: "/emergencyuser/profile" },
        { title: "Public", icon: "mdi-account-group", path: "/emergencyuser/public" },
        {
          title: "Conflict Reports",
          icon: "mdi-source-repository-multiple",
          path: "/emergencyuser/conflictReports",
        },
        {
          title: "Analytics",
          icon: "mdi-home-analytics",
          path: "/emergencyuser/analytics",
        },
        {
          title: "My Reports",
          icon: "mdi-file-chart",
          path: "/emergencyuser/myReport",
        },
      ],

      dynamic: {
        title: "Dynamic Data",
        icon: "mdi-folder",
        visible: false,
        dynamicItems: [
          {
            title: "Scenerios",
            path: "/emergencyuser/dynamicData/scenerios",
          },
          {
            title: "Animals",
            path: "/emergencyuser/dynamicData/animals",
          },
          {
            title: "Animal Activities",
            path: "/emergencyuser/dynamicData/animalActivities",
          },
          {
            title: "Animal Status",
            path: "/emergencyuser/dynamicData/animalStatus",
          },
          {
            title: "Mitigations",
            path: "/emergencyuser/dynamicData/mitigationTypes",
          },
          {
            title: "Land Types",
            path: "/emergencyuser/dynamicData/landTypes",
          },
          {
            title: "Gender",
            path: "/emergencyuser/dynamicData/gender",
          },
          {
            title: "Breach Types",
            path: "/emergencyuser/dynamicData/breachType",
          },
          {
            title: "Barrier Types",
            path: "/emergencyuser/dynamicData/barrierType",
          },
          {
            title: "Conflict Types",
            path: "/emergencyuser/dynamicData/conflictType",
          },
          {
            title: "Crop Types",
            path: "/emergencyuser/dynamicData/cropType",
          },
        ],
      },

      report: {
        title: "Case Related",
        icon: "mdi-folder",
        visible: false,
        reportItems: [
          {
            title: "Report Case",
            path: "/emergencyuser/reportCase",
          },
          {
            title: "Resolve Case",
            path: "/emergencyuser/resolveCase",
          },
          {
            title: "Release Case",
            path: "/emergencyuser/releaseCase",
          },
        ],
      },
      right: null,
    };
  },
  methods: {},
};
</script>

<style scoped>
/* reserves the column the fixed sidebar occupies from md up */
.sidebar-slot {
  flex: 0 0 0 !important;
  max-width: 0 !important;
  width: 0 !important;
}
@media (min-width: 960px) {
  .sidebar-slot {
    flex: 0 0 280px !important;
    max-width: 280px !important;
    width: 280px !important;
  }
}

.main-content-flex {
  flex: 1 1 auto !important;
  max-width: 100% !important;
  width: 100% !important;
}

@media (min-width: 960px) {
  .main-content-flex {
    max-width: calc(100% - 280px) !important;
    width: calc(100% - 280px) !important;
  }
}
</style>